var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalExitChat = ModalExitChat;
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _chatModReactComponentsWeb = require("@olxbr/chat-mod-react-components-web");
var _dsWeb = require("@olxbr/ds-web");
var _Modal = require("../Modal");
var _Icons = require("./Icons");
var Lurker = _interopRequireWildcard(require("../../helpers/lurker"));
var _jsxRuntime = require("react/jsx-runtime");
var _jsxFileName = "/Users/natalia.silva/Documents/OLX-PROJECTS/chatmod-react-components/packages/tips/src/components/ModalExitChat/index.js";
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function ModalExitChat(_ref) {
  var _this = this;
  var isOpen = _ref.isOpen,
    isMsite = _ref.isMsite,
    accountId = _ref.accountId,
    chatId = _ref.chatId,
    clickCloseModalCallback = _ref.clickCloseModalCallback,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'soft' : _ref$variant;
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  (0, _react.useEffect)(function () {
    if (variant === 'hard') {
      setData(hardVersion);
    } else if (variant === 'soft') {
      setData(softVersion);
    }
  }, [variant]);
  var clickCloseModal = function clickCloseModal() {
    Lurker.clickCloseSecurityModal({
      chat_id: chatId,
      variant: variant
    });
    clickCloseModalCallback();
  };
  var softVersion = {
    id: 'soft',
    description: 'Mantenha a negociação no chat e aumente sua proteção contra fraudes.',
    linkText: 'Vendendo na OLX com segurança',
    title: 'Como se proteger ao sair do chat?',
    items: [{
      id: '1',
      icon: _Icons.CreditCardIcon,
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMsite,
        display: "inline",
        children: [(0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMsite,
          weight: "bold",
          display: "inline",
          children: "Nunca"
        }), "\xA0envie seus dados a outra pessoa (Email, CPF, RG ou cart\xE3o de cr\xE9dito)."]
      })
    }, {
      id: '2',
      icon: _Icons.DealIcon,
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMsite,
        display: "inline",
        children: [(0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMsite,
          weight: "bold",
          display: "inline",
          children: "Nunca"
        }), "\xA0pague taxas ou valores adicionais via whatsapp, email ou links suspeitos."]
      })
    }, {
      id: '3',
      icon: _Icons.MoneyIcon,
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMsite,
        display: "inline",
        children: ["A OLX\xA0", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMsite,
          weight: "bold",
          display: "inline",
          children: "nunca"
        }), "\xA0pede pagamento de produtos links ou pix via whatsapp ou email."]
      })
    }, {
      id: '4',
      icon: _Icons.SafeBuyIcon,
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMsite,
        display: "inline",
        children: ["Ao vender com Garantia da OLX,\xA0", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMsite,
          weight: "bold",
          display: "inline",
          children: "sempre"
        }), "\xA0confirme o status do pagamento em detalhes da venda antes do envio do produto."]
      })
    }, {
      id: '5',
      icon: _Icons.UsersIcon,
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMsite,
        display: "inline",
        children: ["Atendentes ou representantes da OLX\xA0", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMsite,
          weight: "bold",
          display: "inline",
          children: "nunca"
        }), "\xA0utilizam o chat ou whatsapp."]
      })
    }]
  };
  var hardVersion = {
    id: 'hard',
    title: 'Viu algum dos comportamentos abaixo no whatsapp? É golpe!',
    items: [{
      id: '1',
      icon: _Icons.CreditCardIcon,
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMsite,
        display: "inline",
        children: ["Pedidos para envio de\xA0", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMsite,
          weight: "bold",
          display: "inline",
          children: "dados pessoais"
        }), "\xA0(Email, CPF, RG ou cart\xE3o de cr\xE9dito)."]
      })
    }, {
      id: '2',
      icon: _Icons.DealIcon,
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMsite,
        display: "inline",
        children: ["Solicita\xE7\xE3o de pagamento de\xA0", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMsite,
          weight: "bold",
          display: "inline",
          children: "taxas de libera\xE7\xE3o."
        })]
      })
    }, {
      id: '3',
      icon: _Icons.MoneyIcon,
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMsite,
        display: "inline",
        children: ["Pedidos de pagamentos da\xA0", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMsite,
          weight: "bold",
          display: "inline",
          children: "Garantia da OLX"
        }), "\xA0por whatsapp ou email."]
      })
    }, {
      id: '4',
      icon: _Icons.SafeBuyIcon,
      text: (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
        isMobile: isMsite,
        display: "inline",
        children: ["Fraudadores se dizendo\xA0", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMsite,
          weight: "bold",
          display: "inline",
          children: "representantes da OLX"
        }), "\xA0no whatsapp."]
      })
    }]
  };
  if (!(data != null && data.items)) return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  var getItems = function getItems() {
    var items = data.items;
    return isMsite ? items.slice(0, 3) : items;
  };
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: (0, _jsxRuntime.jsx)(_Modal.Modal, {
      isOpen: isOpen,
      onCloseModal: clickCloseModal,
      preventCloseOnOutsideClick: isMsite,
      children: (0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
        alignItems: "flex-start",
        flexDirection: "column",
        children: [isMsite ? (0, _jsxRuntime.jsx)(_dsWeb.Text.SubtitleMedium, {
          color: variant === "hard" && "--color-feedback-error-110",
          marginBottom: "--spacing-2",
          children: data.title
        }) : (0, _jsxRuntime.jsx)(_dsWeb.Text.SubtitleLarge, {
          color: variant === "hard" && "--color-feedback-error-110",
          marginBottom: "--spacing-2",
          children: data.title
        }), (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMsite,
          children: ["Fraudadores se aproveitam da ", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
            isMobile: isMsite,
            weight: "bold",
            display: "inline",
            children: "inseguran\xE7a"
          }), " em aplicativos de mensagem para aplicar golpes, ent\xE3o fique de olho:"]
        }), (0, _jsxRuntime.jsx)(_dsWeb.Flex, {
          alignItems: "flex-start",
          flexDirection: "column",
          marginTop: "--spacing-2",
          children: getItems().map(function (item) {
            return (0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
              flexDirection: "row",
              marginBottom: "--spacing-1-5",
              children: [item.icon, (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
                isMobile: isMsite,
                children: item.text
              })]
            }, item.id);
          })
        }), (0, _jsxRuntime.jsxs)(_chatModReactComponentsWeb.TextBody, {
          isMobile: isMsite,
          marginBottom: "--spacing-2",
          children: ["E lembre-se, negociando no chat voc\xEA evita ", (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.TextBody, {
            isMobile: isMsite,
            weight: "bold",
            display: "inline",
            children: "dores de cabe\xE7a na negocia\xE7\xE3o."
          })]
        }), (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.RateBox, {
          luckerDetail: "security-modal-chat-rate",
          idLocalStorage: accountId,
          isMobile: isMsite,
          chatId: chatId
        })]
      })
    })
  });
}
ModalExitChat.propTypes = {
  isOpen: _propTypes["default"].bool.isRequired,
  isMsite: _propTypes["default"].bool.isRequired,
  accountId: _propTypes["default"].string.isRequired,
  chatId: _propTypes["default"].string.isRequired,
  clickCloseModalCallback: _propTypes["default"].func.isRequired,
  variant: _propTypes["default"].string.isRequired
};
var _default = ModalExitChat;
exports["default"] = _default;